// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ac272a24","644":"8e8fa978"}[chunkId] + ".chunk.js";
};